export default __webpack_public_path__ + "static/hw_neopixel-887df44f601b2434969401b83aee9db1.jpg";